import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ROUTE_RULE_BASE_PATH } from '../../../../../../../../../features/fix/route/route-rule-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'routing-rule',
        label: 'OMS',
        to: ROUTE_RULE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
